export default function JourneyPath({ className = "", dark = false }) {
    const stroke = dark ? "#C9A66B" : "#C9A66B";
    return (
        <div className={`flex justify-center ${className}`} aria-hidden="true">
            <svg width="220" height="30" viewBox="0 0 220 30" fill="none" data-testid="journey-path-divider">
                <path
                    d="M4 15 C 34 4, 64 26, 94 15 S 154 4, 184 15 S 210 24, 216 15"
                    stroke={stroke}
                    strokeWidth="1.6"
                    strokeLinecap="round"
                    strokeDasharray="0.1 6.5"
                    opacity="0.85"
                />
            </svg>
        </div>
    );
}
